module.exports = __webpack_public_path__ + "static/media/topThread.ba331231.svg";